import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./view-application-details-rc.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./view-application-details-rc.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ApplicationBaseComponent } from "../../../../../shared/components/application-base/application-base.component";
import { SharedConstants } from "../../../../../shared/constants/shared.constants";
import { ViewApplicationDetailsRcConstants } from "./view-application-details-rc.constants";
import { AflaModuleStrategyService } from "../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ViewApplicationService } from "../../../view-application.service";
import { ActivatedRoute } from "@angular/router";
import { RouterParamsService } from "../../../../../shared/services/route-params.service";
import { AppControllerService } from "../../../../../app-controller.service";
import { CRUDOperation } from "../../../../../shared/models/crud-operation-enum.model";
import { AlertType } from "../../../../../shared/models/alert";
let ViewApplicationDetailsRcComponent = class ViewApplicationDetailsRcComponent extends ApplicationBaseComponent {
    aflaModuleStrategyService;
    viewApplicationService;
    route;
    routerParamsService;
    appController;
    changeDetectorRefs;
    detailsForm;
    // Labels
    descriptionLabel = ViewApplicationDetailsRcConstants.DESCRIPTION_LABEL;
    typeLabel = ViewApplicationDetailsRcConstants.TYPE_LABEL;
    reasonForApplicationLabel = ViewApplicationDetailsRcConstants.REASON_FOR_APPLICATION;
    typeOfTransferLabel = ViewApplicationDetailsRcConstants.TYPE_OF_TRANSFER_LABEL;
    propertyTypeLabel = ViewApplicationDetailsRcConstants.PROPERTY_TYPE_LABEL;
    ratesAccountNumberLabel = ViewApplicationDetailsRcConstants.RATES_ACCOUNT_NUMBER_LABEL;
    electronicReferenceLabel = ViewApplicationDetailsRcConstants.ELECTRONIC_REFERENCE_LABEL;
    attorneyReferenceLabel = ViewApplicationDetailsRcConstants.ATTORNEY_REFERENCE_LABEL;
    councilReferenceLabel = ViewApplicationDetailsRcConstants.COUNCIL_REFERENCE_LABEL;
    validationMessages = ViewApplicationDetailsRcConstants.VALIDATION_MESSAGES;
    saveBtnPlaceholder = SharedConstants.SAVE_LABEL;
    // Controls
    descriptionFormControlName = ViewApplicationDetailsRcConstants.DESCRIPTION_FORM_CONTROL_NAME;
    typeFormControlName = ViewApplicationDetailsRcConstants.TYPE_FORM_CONTROL_NAME;
    reasonForApplicationFormControlName = ViewApplicationDetailsRcConstants.REASON_FOR_APPLICATION_CONTROL_NAME;
    typeOfTransferFormControlName = ViewApplicationDetailsRcConstants.TYPE_OF_TRANSFER_CONTROL_NAME;
    propertyTypeFormControlName = ViewApplicationDetailsRcConstants.PROPERTY_TYPE_CONTROL_NAME;
    ratesAccountNumberFormControlName = ViewApplicationDetailsRcConstants.RATES_ACCOUNT_NUMBER_CONTROL_NAME;
    electronicReferenceFormControlName = ViewApplicationDetailsRcConstants.ELECTRONIC_REFERENCE_CONTROL_NAME;
    attorneyReferenceFormControlName = ViewApplicationDetailsRcConstants.ATTORNEY_REFERENCE_CONTROL_NAME;
    councilReferenceFormControlName = ViewApplicationDetailsRcConstants.COUNCIL_REFERENCE_CONTROL_NAME;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypes = [];
    typeOfTransferLookupOptions = [];
    referenceNumberControlName = ViewApplicationDetailsRcConstants.REFERENCE_NUMBER_CONTROL_NAME;
    referenceNumberLabel = ViewApplicationDetailsRcConstants.REFERENCE_NUMBER_LABEL;
    application;
    getApplicationSaveObservableSubscription;
    constructor(aflaModuleStrategyService, viewApplicationService, route, routerParamsService, appController, changeDetectorRefs) {
        super(route, routerParamsService, aflaModuleStrategyService);
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.viewApplicationService = viewApplicationService;
        this.route = route;
        this.routerParamsService = routerParamsService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
    }
    ngOnInit() {
        this.listenForRouteParamChange();
        this.initForm();
        if (this.aflaModuleStrategyService.lookups.has("applicationTypes") && this.aflaModuleStrategyService.lookups.has("transferType")) {
            this.applicationTypes = this.aflaModuleStrategyService.lookups.get("applicationTypes");
            this.typeOfTransferLookupOptions = this.aflaModuleStrategyService.lookups.get("transferType");
        }
        else {
            this.getLookups();
        }
        this.getLookups();
    }
    handleRouteChange() {
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get("detailsForm");
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.moduleID}`,
        };
        this.viewApplicationService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsRcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        const applicationTypes = [];
        const typeOfTransfer = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name?.toLowerCase() === "applicationtype") {
                    applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name?.toLowerCase() === "transfertype") {
                    typeOfTransfer.push(JSON.parse(item.content));
                }
            });
        }
        this.aflaModuleStrategyService.lookups.set("applicationTypes", applicationTypes);
        this.aflaModuleStrategyService.lookups.set("transferType", typeOfTransfer);
        this.applicationTypes = applicationTypes;
        this.typeOfTransferLookupOptions = typeOfTransfer;
        this.getApplication();
        this.changeDetectorRefs.detectChanges();
    }
    getApplication() {
        const params = {
            $filter: `jobId eq ${this.jobID}`,
        };
        this.viewApplicationService
            .getApplicationObservable(this.aflaModuleStrategyService.applicationServiceUrl, params)
            .subscribe({
            next: (response) => {
                this.onGetApplicationCompleted(response);
            },
            error: (error) => {
                this.appController.handleServerErrorMessage(ViewApplicationDetailsRcConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetApplicationCompleted(response) {
        if (response && response.value.length > 0) {
            this.detailsForm.reset();
            const application = response.value[0];
            this.application = application;
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
            this.detailsForm.get(this.referenceNumberControlName).setValue(application.referenceNumber);
            this.detailsForm.get(this.typeFormControlName).setValue(application.type);
            this.detailsForm.get(this.reasonForApplicationFormControlName).setValue(application.reasonForApplication);
            this.detailsForm.get(this.typeOfTransferFormControlName).setValue(application.typeOfTransfer);
            this.detailsForm.get(this.propertyTypeFormControlName).setValue(application.propertyType);
            this.detailsForm.get(this.ratesAccountNumberFormControlName).setValue(application.ratesAccountNumber);
            this.detailsForm.get(this.electronicReferenceFormControlName).setValue(application.electronicReference);
            this.detailsForm.get(this.attorneyReferenceFormControlName).setValue(application.attorneyReference);
            this.detailsForm.get(this.councilReferenceFormControlName).setValue(application.councilReference);
            this.detailsForm.get(this.descriptionFormControlName).disable();
            this.detailsForm.get(this.referenceNumberControlName).disable();
            this.detailsForm.get(this.typeFormControlName).disable();
            this.detailsForm.get(this.reasonForApplicationFormControlName).disable();
            this.detailsForm.get(this.typeOfTransferFormControlName).disable();
            this.detailsForm.get(this.propertyTypeFormControlName).disable();
        }
        this.changeDetectorRefs.detectChanges();
    }
    onBtnSaveClicked($event) {
        if (this.detailsForm.valid) {
            const application = {
                description: this.detailsForm.get("description").value,
                type: this.detailsForm.get("applicationType").value,
                reasonForApplication: this.detailsForm.get("reasonForApplication").value,
                typeOfTransfer: this.detailsForm.get("typeOfTransfer").value,
                propertyType: this.detailsForm.get("propertyType").value,
                ratesAccountNumber: this.detailsForm.get("ratesAccountNumber").value,
                electronicReference: this.detailsForm.get("electronicReference").value,
                attorneyReference: this.detailsForm.get("attorneyReference").value,
                councilReference: this.detailsForm.get("councilReference").value,
            };
            this.getApplicationSaveObservableSubscription =
                this.viewApplicationService.getApplicationSaveObservable(this.aflaModuleStrategyService.applicationServiceUrl, this.application.id, application)
                    .subscribe({
                    next: (appSaveresponse) => {
                        this.appController.showMessage(SharedConstants.UPDATE_SUCCESS, AlertType.Success);
                        this.getApplication();
                    },
                    error: (error) => {
                        this.appController.handleServerErrorMessage(ViewApplicationDetailsRcConstants.STEP_TITLE, error, CRUDOperation.Update);
                    }
                });
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: AflaModuleStrategyService },
        { type: ViewApplicationService },
        { type: ActivatedRoute },
        { type: RouterParamsService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
ViewApplicationDetailsRcComponent = __decorate([
    Component({
        selector: "app-view-application-details-rc",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], ViewApplicationDetailsRcComponent);
export { ViewApplicationDetailsRcComponent };
